import React from "react";
import { InputDate, Switch } from "../../Helpers/Input/Input";
import trans from "../../../utils";
import dayjs from "dayjs";

export default function DriverDateInfo({ addData }) {
	return (
		<div className="driverinfo mb-24">
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("date info")}
			</p>
			<div className="row">
				<div className="col-lg-6">
					<InputDate
						title={trans("Contract start date")}
						id="contractStartDate"
						name="contractStartDate"
						onBlur={(value) =>
							addData.setFieldTouched("contractStartDate", true)
						}
						onChange={(value) =>
							addData.setFieldValue(
								"contractStartDate",
								value ? dayjs(value).toISOString() : ""
							)
						}
						errors={addData.errors.contractStartDate}
						touched={addData.touched.contractStartDate}
						value={addData.values.contractStartDate || ""}
					/>
				</div>
				<div className="col-lg-6">
					<InputDate
						title={trans("Contract expiry date")}
						id="contractExpireDate"
						name="contractExpireDate"
						onBlur={(value) =>
							addData.setFieldTouched("contractExpireDate", true)
						}
						onChange={(value) =>
							addData.setFieldValue(
								"contractExpireDate",
								value ? dayjs(value).toISOString() : ""
							)
						}
						errors={addData.errors.contractExpireDate}
						touched={addData.touched.contractExpireDate}
						value={addData.values.contractExpireDate || ""}
						min={
							addData.values.contractStartDate
								? dayjs(addData.values.contractStartDate).add(1, "day")
								: undefined
						}
						disabled={addData.values.contractStartDate ? false : true}
					/>
				</div>
			</div>
			{/* <div className="flex-between for w-50 mb-16">
				<label className="form-label">
					{trans("Contract Expire Reminder")}
				</label>
				<div className="y-25">
					<Switch
						id="contractExpireReminder"
						name="contractExpireReminder"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						value={addData.values.contractExpireReminder || ""}
						disabled={addData.values.contractExpireDate ? false : true}
					/>
				</div>
			</div> */}
			<div className="row">
				<div className="col-lg-6">
					<InputDate
						title={trans("license start date")}
						id="licenseStartDate"
						name="licenseStartDate"
						onBlur={(value) =>
							addData.setFieldTouched("licenseStartDate", true)
						}
						onChange={(value) =>
							addData.setFieldValue(
								"licenseStartDate",
								value ? dayjs(value).toISOString() : ""
							)
						}
						errors={addData.errors.licenseStartDate}
						touched={addData.touched.licenseStartDate}
						value={addData.values.licenseStartDate || ""}
					/>
				</div>
				<div className="col-lg-6">
					<InputDate
						title={trans("license expiry date")}
						id="licenseExpireDate"
						name="licenseExpireDate"
						onBlur={(value) =>
							addData.setFieldTouched("licenseExpireDate", true)
						}
						onChange={(value) =>
							addData.setFieldValue(
								"licenseExpireDate",
								value ? dayjs(value).toISOString() : ""
							)
						}
						errors={addData.errors.licenseExpireDate}
						touched={addData.touched.licenseExpireDate}
						value={addData.values.licenseExpireDate || ""}
						min={
							addData.values.licenseStartDate
								? dayjs(addData.values.licenseStartDate).add(1, "day")
								: undefined
						}
						disabled={addData.values.licenseStartDate ? false : true}
					/>
				</div>
			</div>
			{/* <div className="flex-between">
				<div className="d-flex justify-content-between align-items-center w-50">
					<label className="form-label">
						{trans("license Expire Reminder")}
					</label>
					<div className="y-25">
						<Switch
							onBlur={addData.handleBlur}
							onChange={addData.handleChange}
							id="licenseExpireReminder"
							name="licenseExpireReminder"
							value={addData.values.licenseExpireReminder || ""}
							disabled={addData.values.licenseExpireDate ? false : true}
						/>
					</div>
				</div>
			</div> */}
		</div>
	);
}
